module.exports = __webpack_public_path__ + "3482cb6a841af89e106fad595f925942.pdf";